import { Component } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { SearchesCommon } from '../searches.common';

import { TrDetailComponent } from '../components/searches-detail/tr-detail/tr-detail.component';

@Component({
  selector: 'artemis-searches-tr',
  templateUrl: './searches-tr.component.html',
  styleUrls: ['./searches-tr.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class SearchesTrComponent extends SearchesCommon {

  displayedColumns: string[] = ['checkbox', 'matchedTerm', 'categories', 'countryLinks', 'matchStrength', 'options', 'matched'];
  currentPage: number;

  selectDetail(item: any) {
    this.dialogRef = this.dialog.open(TrDetailComponent, { data : item, autoFocus: false, width: '1300px'});
  }
}
